import "moment/locale/nb";
import React, { Fragment } from "react";
import { Heading, RadioGroup, Text } from "@telia/teddy";
import cn from "classnames";
import moment from "moment";
import { getWeekdayIndex, findOpeningTimeForDay, isShopOpen } from "./pickup-in-store-helpers";
import { ShopDetails, OpeningHours } from "../../../../../../models/state";
import TEXT from "../../../text-consts";
import "./PickupInStoreShop.less";

interface PickupInStoreShopProps extends Pick<
    ShopDetails,
    "code" | "name" | "street" | "zip" | "city" | "quantity" | "open"
> {
    selectedShop?: ShopDetails;
}

interface renderOpeningTimeProps {
    open: OpeningHours[];
}

const renderOpeningTime: React.FC<renderOpeningTimeProps> = ({ open }) => {
    const weekdayIndex = getWeekdayIndex();
    const openingHours = findOpeningTimeForDay(open, weekdayIndex);
    const isOpen = openingHours ? isShopOpen(openingHours.hours, moment()) : false;

    if (isOpen && openingHours) {
        return (
            <Fragment>
                <span className="pickup-in-store-point-open">{TEXT.OPEN}</span>
                {` - ${TEXT.CLOSING} ${openingHours.hours.split("-")[1].substring(0, 2)}`}
            </Fragment>
        );
    }

    return <span className="pickup-in-store-point-closed">{TEXT.CLOSED}</span>;
};

const PickupInStoreShop: React.FC<PickupInStoreShopProps> = ({
    code,
    name,
    street,
    zip,
    city,
    quantity,
    open,
    selectedShop,
}) => {
    const isSelected = code === selectedShop?.code;
    return (
        <div className={cn("pickup-in-store-point", { "pickup-in-store-point--selected": isSelected })}>
            <RadioGroup.Item>
                <RadioGroup.Trigger value={code} />
                <RadioGroup.Label>
                    <div className="pickup-in-store-point--info">
                        <div className="pickup-in-store-point--infotext">
                            <Heading as="h3" variant="title-100">
                                {name.toLowerCase()}
                            </Heading>
                            <Text mb="100" variant="additional-100">
                                {`${street}`.toLowerCase()}
                            </Text>
                            <Text mb="100" variant="additional-100">
                                {`${zip} ${city}`.toLowerCase()}
                            </Text>
                            <Text mb="100" variant="additional-100">
                                {renderOpeningTime({ open })}
                            </Text>
                        </div>
                        {quantity && <div className="pickup-in-store-point--instock">{TEXT.QUANTITY(quantity)}</div>}
                    </div>
                </RadioGroup.Label>
            </RadioGroup.Item>
        </div>
    );
};

export default PickupInStoreShop;
